import { useEmbedStore } from './embedStore';
import { useLeagueStore } from './leagueStore';
import { getTenantConfig } from './tenantConfig';
import { getCurrentTenantConfig } from './tenantStore';
import { useUserStore } from './userStore';

export function isArsenalSessionContext(): boolean {
  const user = useUserStore.getState();
  const tenant = getCurrentTenantConfig();
  const arsenalLeagueId = getTenantConfig('arsenal').leagueId;
  const isTslh = tenant.id === 'tslh' || user.is_tslh_session;
  const isOidcAuthFlow = ['/auth/bpm', '/auth/callback'].some((path) => window.location.pathname.startsWith(path));

  return Boolean(user.is_bpm_session || tenant.authMode === 'oidc'
    || user.currentLeagueId === arsenalLeagueId
    || useLeagueStore.getState().selectedLeague?.id === arsenalLeagueId
    || isOidcAuthFlow || (useEmbedStore.getState().isEmbed && !isTslh));
}
